import { type Guard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const checkIfDressingDetailsEnabled: Guard = function (args): boolean {
  const { context } = args;
  const { product } = context;

  return product?.enableDressingDetails ?? true;
};
